export default class PresetComponentVO {
    /**
     * @param {string} property
     * @param {int} id
     * @param {int[]} compValues
     * @param {string} classUnit
     */
    constructor(property, id, compValues, classUnit) {
        this.id = id;
        this._property = property;
        this._compValues = compValues;
        this._classUnit = classUnit;
        this._classPrefixName = 'comp';
        this._classPresetCompDelimiter = '-';
    }

    get id() {
        return this._id;
    }

    set id(id) {
        this._id = id;
    }

    get classPrefixName() {
        return this._classPrefixName;
    }

    set classPrefixName(value) {
        this._classPrefixName = value;
    }

    get classPresetCompDelimiter() {
        return this._classPresetCompDelimiter;
    }

    set classPresetCompDelimiter(value) {
        this._classPresetCompDelimiter = value;
    }

    get className() {
        return this._className;
    }

    set className(className) {
        this._className = className;
    }

    get property() {
        return this._property;
    }

    set property(value) {
        this._property = value;
    }

    get compValues() {
        return this._compValues;
    }

    set compValues(value) {
        this._compValues = value;
    }

    get classUnit() {
        return this._classUnit;
    }

    set classUnit(value) {
        this._classUnit = value;
    }

    getClassName() {
        return this._classPrefixName
            + this._classPresetCompDelimiter
            + this._compValues.join(this._classPresetCompDelimiter);
    }

    getComponentMarkup(numberOfDivisionsInComponent) {
        const compMarkup = `<div class="preset-comp"></div>`;
        let markup = '';
        for (let i = 0; i < numberOfDivisionsInComponent; i++) {
            markup += compMarkup;
        }
        return markup;
    }

    render(selectedPresetID) {
        if (selectedPresetID === this._id) {
            this._className = this.getClassName() + ' -selected';
        } else {
            this._className = this.getClassName();
        }

        return `<div class="preset-wrapper js-comp-preset ${this._className}" data-preset-id="${this._id}">
               ${this.getComponentMarkup(this.compValues.length)}
                </div>`;
    }

    toObject() {
        const obj = {};
        obj.id = this.id;
        obj.compValues = this.compValues;
        obj.classUnit = this.classUnit;

        return obj;
    }
}